<template>
  <div class="banner">
    <div class="mm" :style="img"></div>
   
    <!-- <div class="banner-title">
      <p>{{title}}</p>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: {
    title: {
      type: String,
      default: ""
    },
    img: {
      type: Object,
      default: {}
    }
  }
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 40vh;
  display: flex;
  position: relative;
  overflow: hidden;
  background-color: #fff;

  .mm {
    position: absolute;
    width: 100%;
    height: 100%;
    
    // padding: 10px;
    // margin: -10px;
    // background-position: center;
    // background-size: cover;
	  // background-repeat: no-repeat;
    // filter: blur(10px);

    // background-image: url(../assets/img/bgtop.jpg);
    background-size: 100% 100%;
	  background-repeat: no-repeat;
  }

  // img {
  //   position: absolute;
  //   //width: 1240px;
  //   height: 100%;
  //   left: 50%;
  //   transform: translate(-50%, 0);
  // }

  &-title {
    position: absolute;
    color: #fff;
    font-size: 45px;
    font-weight: 400;
    line-height: 300px;
    text-align: center;
    width: 100%;
  }
}
</style>